import { z } from "zod";
/** Email queue (docs/email.md). Statuses are exactly these four. */
export const EmailStatus = z.enum(["queued", "sent", "expired", "error"]);
export const EmailTransportKind = z.enum(["none", "acs", "capture"]);
/** What the worker last reported about its email sender. Never includes the connection string. */
export const EmailWorkerStatus = z.object({
    transport: EmailTransportKind,
    senderAddress: z.string().nullable(),
    endpointHost: z.string().nullable(),
    retryDelayMs: z.number().int(),
    pollMs: z.number().int(),
    startedAt: z.string(),
    seenAt: z.string(),
    /** False when the worker has missed three polls (and at least a minute). */
    online: z.boolean(),
});
export const EmailTestStatus = z.object({
    emailTestUi: z.literal(true),
    /** Null when no worker has ever reported. */
    worker: EmailWorkerStatus.nullable(),
    defaultMaxRetries: z.number().int(),
    minTtlSeconds: z.number().int(),
    maxTtlSeconds: z.number().int(),
});
export const EmailTestSendInput = z.object({
    to: z.string().trim().email(),
    subject: z.string().trim().min(1).max(200),
    body: z.string().trim().min(1).max(5000),
    ttlSeconds: z
        .number()
        .int()
        .min(60)
        .max(7 * 24 * 60 * 60),
});
export const EmailDeliveryError = z.object({
    attempt: z.number().int(),
    code: z.string(),
    message: z.string(),
    statusCode: z.number().int().nullable(),
    occurredAt: z.string(),
});
export const EmailSummary = z.object({
    id: z.number().int(),
    kind: z.string(),
    recipient: z.string(),
    subject: z.string(),
    status: EmailStatus,
    attempts: z.number().int(),
    maxRetries: z.number().int(),
    expiresAt: z.string(),
    nextAttemptAt: z.string().nullable(),
    sentAt: z.string().nullable(),
    providerMessageId: z.string().nullable(),
    createdAt: z.string(),
    lastError: EmailDeliveryError.nullable(),
});
export const EmailList = z.object({ items: z.array(EmailSummary) });
export const EmailListQuery = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
/** Bodies are cleared once an email is final, so they are null for sent, expired and exhausted rows. */
export const EmailDetail = EmailSummary.extend({
    textBody: z.string().nullable(),
    htmlBody: z.string().nullable(),
    errors: z.array(EmailDeliveryError),
});
//# sourceMappingURL=email.js.map